import Navbar from '../components/layout/Navbar'
import Footer from '../components/layout/Footer'
import Hero from '../components/sections/Hero'
import Services from '../components/sections/Services'
import WhyUs from '../components/sections/WhyUs'
import ServiceAreas from '../components/sections/ServiceAreas'
import Reviews from '../components/sections/Reviews'
import Contact from '../components/sections/Contact'
import CtaBanner from '../components/sections/CtaBanner'

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyUs />
        <ServiceAreas />
        <Reviews />
        <Contact />
        <CtaBanner />
      </main>
      <Footer />
    </>
  )
}
